import { useState } from "react";

export const Christmas = () => {
  const [people, setPeople] = useState([
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
    { name: "", partner: "" },
  ]);

  const [results, setResults] = useState(null);
  const [revealing, setRevealing] = useState(false);

  function updatePerson(i, field, value) {
    const copy = [...people];
    copy[i][field] = value;
    setPeople(copy);
  }

  function assign() {
    // Include all people with names (partner is optional)
    const filled = people.filter(p => p.name.trim() !== "");

    if (filled.length < 2) return;

    setResults(null);
    setRevealing(true);

    setTimeout(() => {
      const assignments = generateAssignments(filled);
      setResults(assignments);
      setRevealing(false);
    }, 1500);
  }

  return (
    <div style={{ fontFamily: "sans-serif", padding: 20, maxWidth: 500 }}>
      <h2>🎄 Secret Santa assignment</h2>
      <p>Enter people. Partners are optional - people in relationships cannot be paired together.</p>

      {people.map((p, i) => (
        <div key={i} style={{ marginBottom: 10 }}>
          <input
            placeholder="Name"
            value={p.name}
            onChange={e => updatePerson(i, "name", e.target.value)}
            style={{ marginRight: 6 }}
          />
          <input
            placeholder="Partner"
            value={p.partner}
            onChange={e => updatePerson(i, "partner", e.target.value)}
          />
        </div>
      ))}

      <button onClick={assign} style={{ marginTop: 10 }}>
        Assign 🎁
      </button>

      {revealing && (
        <div
          style={{
            marginTop: 20,
            fontSize: 26,
            fontWeight: "bold",
            animation: "pulse 0.8s infinite",
          }}
        >
          🎅 Drawing names...
        </div>
      )}

      {results && (
        <div style={{ marginTop: 20 }}>
          <h3>Results</h3>
          {Object.entries(results).map(([giver, receiver]) => (
            <div key={giver} style={{ fontSize: 18, marginBottom: 8 }}>
              <strong>{giver}</strong> → {receiver}
            </div>
          ))}
        </div>
      )}

      {results === null && !revealing && (
        <div style={{ marginTop: 20, color: "red" }}>
          Could not generate valid assignments. Try again or check your partner relationships.
        </div>
      )}

      <style>{`
        @keyframes pulse {
          0% { opacity: 1; }
          50% { opacity: 0.4; }
          100% { opacity: 1; }
        }
      `}</style>
    </div>
  );
};


// ------------------------
// Assignment logic
// ------------------------
function generateAssignments(people) {
  // Collect all unique participants (people with names)
  const nameSet = new Set();
  people.forEach(p => {
    const name = p.name.trim();
    if (name) nameSet.add(name);
  });
  
  // Build partner relationships and add partners to the mix
  const partners = {};
  people.forEach(p => {
    const name = p.name.trim();
    const partner = p.partner.trim();
    if (name && partner) {
      partners[name] = partner;
      partners[partner] = name; // Bidirectional relationship
      // Add partner to the participant list if not already there
      if (partner) nameSet.add(partner);
    }
  });
  
  // Convert set to array for assignment
  const names = Array.from(nameSet);

  // Maximum attempts to avoid infinite loop
  const maxAttempts = 1000;
  let attempts = 0;

  while (attempts < maxAttempts) {
    attempts++;
    const shuffled = [...names].sort(() => Math.random() - 0.5);
    let valid = true;
    const assignments = {};

    for (let i = 0; i < names.length; i++) {
      const giver = names[i];
      const receiver = shuffled[i];

      // Can't give to yourself
      if (receiver === giver) {
        valid = false;
        break;
      }

      // Can't give to your partner (if you have one)
      if (partners[giver] && receiver === partners[giver]) {
        valid = false;
        break;
      }

      assignments[giver] = receiver;
    }

    if (valid) return assignments;
  }

  // If we couldn't find a valid assignment, return null
  console.error("Could not generate valid assignments after", maxAttempts, "attempts");
  return null;
}

export default Christmas;

